module.exports = __webpack_public_path__ + "img/a3.f40eacdf.png";